import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4174d0e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "info_txt_wrapper"
};
const _hoisted_2 = {
  class: "info_detail_title"
};
const _hoisted_3 = {
  class: "info_detail_des"
};
const _hoisted_4 = {
  class: "info_img_wrapper"
};
const _hoisted_5 = {
  class: "info_detail_img",
  alt: ""
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["introduction_detail_item", {
      reverse_wrapper: $props.options.flexReverse
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t($props.options.title)), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t($props.options.des)), 1)]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [[_directive_lazy, require(`@/assets/home-wrapper/index/advertise/${$props.options.image}`)]])])], 2);
}